import styles from './Design2.css?inline';

export class AffordabilityDesign2 {
  private readonly instanceId: string;
  private containerElement: HTMLDivElement;
  private widgetData: any;
  private onOpen: () => void;
  private language = 'en';

  constructor(widgetData: any, onOpen: () => void) {
    this.instanceId = 'aff3-' + Math.random().toString(36).slice(2, 8);
    this.widgetData = widgetData;
    this.onOpen = onOpen;
    this.containerElement = document.createElement('div');
    this.containerElement.id = `affordability-container-3-${this.instanceId}`;
    this.injectStyles();
  }

  getContainer() {
    return this.containerElement;
  }

  setLanguage(lang: string) {
    if (lang) this.language = lang.toLowerCase();
  }

  private injectStyles() {
    const styleId = 'dabadu-affordability-design3-styles';
    if (!document.getElementById(styleId)) {
      const styleTag = document.createElement('style');
      styleTag.id = styleId;
      styleTag.innerHTML = styles;
      document.head.appendChild(styleTag);
    }
  }

  buildBanner(resp: any) {
    if (this.containerElement.hasChildNodes()) return;

    this.containerElement.className = 'affordability-banner-3';

    // Left side
    const left = document.createElement('div');
    left.className = 'left';

    const logo = document.createElement('img');
    logo.src = this.widgetData?.logoUrl || 'https://uat-widget.apps.dabadu.ai/equifax-logo-rounded-white-bg.png';
    logo.alt = 'Logo';
    logo.className = 'logo';

    const textWrapper = document.createElement('div');
    textWrapper.className = 'text-wrapper';

    const title = document.createElement('div');
    title.className = 'title';
    title.innerText = resp?.banners?.['banner2']?.title || 'Great loan options are waiting for you.';

    const subtitle = document.createElement('div');
    subtitle.className = 'subtitle';
    subtitle.innerText = resp?.banners?.['banner2']?.description || 'Know if you qualify before you buy.';

    textWrapper.appendChild(title);
    textWrapper.appendChild(subtitle);

    left.appendChild(logo);
    left.appendChild(textWrapper);

    // Right side
    const right = document.createElement('div');
    right.className = 'right';

    const btn = document.createElement('button');
    btn.className = 'cta';
    btn.innerText = resp?.banners?.['banner2']?.buttonText || 'Start Your Pre-Approval';
    btn.addEventListener('click', () => {
      if (typeof this.onOpen === 'function') this.onOpen();
    });

    const note = document.createElement('div');
    note.className = 'note';
    note.innerText = resp?.banners?.['banner2']?.note || 'This will NOT impact your Credit';

    right.appendChild(btn);
    right.appendChild(note);

    // Append to container
    this.containerElement.appendChild(left);
    this.containerElement.appendChild(right);
  }
}
